"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _modulesToJsonSchema = _interopRequireDefault(require("../../utils/modules-to-json-schema"));
var _questionAnswerSchema = _interopRequireDefault(require("./question-answer-schema"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var supportedModules = {
  helpSnippet: _questionAnswerSchema["default"]
};
var getFAQSchema = function getFAQSchema(page) {
  var _page$sections;
  return page === null || page === void 0 ? void 0 : (_page$sections = page.sections) === null || _page$sections === void 0 ? void 0 : _page$sections.map(function (section) {
    return (0, _modulesToJsonSchema["default"])({
      supportedModules: supportedModules,
      modules: section.modules
    });
  }).filter(function (section) {
    return section.length > 0;
  }).flat();
};
var getFAQSchemaV2 = function getFAQSchemaV2(page) {
  var helpSnippetsModules = page === null || page === void 0 ? void 0 : page.modules.filter(function (module) {
    return module.contentType === 'helpSnippets';
  });
  return helpSnippetsModules.map(function (module) {
    return (0, _modulesToJsonSchema["default"])({
      supportedModules: supportedModules,
      modules: module.snippets
    });
  }).flat();
};
var createFAQPageSchema = function createFAQPageSchema(_ref) {
  var page = _ref.page;
  var contentType = page.contentType;
  var FAQs = contentType === 'page_v2' ? getFAQSchemaV2(page) : getFAQSchema(page);
  if (!FAQs || FAQs.length === 0) return null;
  return {
    type: 'FAQPage',
    mainEntity: FAQs
  };
};
var _default = createFAQPageSchema;
exports["default"] = _default;